import { isFinanceProject, isGlobalProject } from 'config';

export const getLegalClientRiskLevelFormSectionKeys = (): string[] => {
  if (isFinanceProject()) {
    return ['riskLevel', 'bankAccounts', 'financingSources'];
  }

  if (isGlobalProject()) {
    return ['riskLevel', 'sourcesOfIncome'];
  }

  return [];
};
